var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowLoading)?_c('div',{staticClass:"ga-loading"},[_c('div',{staticClass:"mask rule-mask loading-mask"}),_vm._v(" "),_c('img',{attrs:{"src":_vm.loadingIcon}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.content))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-226cad24","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsLoading/loading.vue
// module id = null
// module chunks = 